import React, { useState } from "react";

export default function SecuritySection({
  currentPassword, newPassword, confirmPassword, passwordError, twoFactor,
  onCurrentPasswordChange, onNewPasswordChange, onConfirmPasswordChange, onTwoFactorChange, onSubmit
}) {
  // Password validation helper
  const isValidPassword = (password) =>
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{6,14}$/.test(password);
  // State for password visibility
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
    // Local password error state for validation
    const [localPasswordError, setLocalPasswordError] = useState("");

  // Eye icon SVG
  const EyeIcon = ({ open }) => (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 11C3.5 5.5 8 3 11 3C14 3 18.5 5.5 21 11C18.5 16.5 14 19 11 19C8 19 3.5 16.5 1 11Z" stroke="#888" strokeWidth="1.5"/>
      <circle cx="11" cy="11" r="3.5" stroke="#888" strokeWidth="1.5"/>
      {open ? null : <line x1="4" y1="18" x2="18" y2="4" stroke="#888" strokeWidth="1.5"/>}
    </svg>
  );

  return (
    <div className="flex flex-col gap-3 px-5 pb-5">
      <div className="relative">
        <input
          type={showCurrent ? "text" : "password"}
          placeholder="Current Password"
          className="bg-[#f6f6f8] border-none rounded-xl px-4 py-3 text-base w-full pr-10"
          value={currentPassword}
          onChange={onCurrentPasswordChange}
        />
        <button
          type="button"
          className="absolute top-1/2 right-3 -translate-y-1/2 p-1 bg-transparent border-none cursor-pointer"
          onClick={() => setShowCurrent(v => !v)}
          tabIndex={-1}
        >
          <EyeIcon open={showCurrent} />
        </button>
      </div>
      <div className="relative">
        <input
          type={showNew ? "text" : "password"}
          placeholder="New Password"
          className="bg-[#f6f6f8] border-none rounded-xl px-4 py-3 text-base w-full pr-10"
          value={newPassword}
          onChange={onNewPasswordChange}
        />
        <button
          type="button"
          className="absolute top-1/2 right-3 -translate-y-1/2 p-1 bg-transparent border-none cursor-pointer"
          onClick={() => setShowNew(v => !v)}
          tabIndex={-1}
        >
          <EyeIcon open={showNew} />
        </button>
      </div>
      <div className="relative">
        <input
          type={showConfirm ? "text" : "password"}
          placeholder="Confirm New Password"
          className="bg-[#f6f6f8] border-none rounded-xl px-4 py-3 text-base w-full pr-10"
          value={confirmPassword}
          onChange={onConfirmPasswordChange}
        />
        <button
          type="button"
          className="absolute top-1/2 right-3 -translate-y-1/2 p-1 bg-transparent border-none cursor-pointer"
          onClick={() => setShowConfirm(v => !v)}
          tabIndex={-1}
        >
          <EyeIcon open={showConfirm} />
        </button>
      </div>
      {(localPasswordError || passwordError) && <div className="text-xs text-red-500 mt-1">{localPasswordError || passwordError}</div>}
      <button
        type="button"
        className="mt-2 px-5 py-2 rounded-xl text-base font-medium transition border"
        style={{
          background: 'var(--color-primary)',
          color: 'var(--color-on-primary)',
          borderColor: 'var(--color-primary)',
        }}
        onClick={() => {
          // Validation checks
          if (!currentPassword || !newPassword || !confirmPassword) {
            setLocalPasswordError("All fields are required.");
            return;
          }
          if (currentPassword === newPassword) {
            setLocalPasswordError("New password must be different from current password.");
            return;
          }
          if (!isValidPassword(newPassword)) {
            setLocalPasswordError("Password must be 6-14 characters and include uppercase, lowercase, number, and symbol.");
            return;
          }
          if (newPassword !== confirmPassword) {
            setLocalPasswordError("New passwords do not match.");
            return;
          }
          setLocalPasswordError("");
          onSubmit();
        }}
        onMouseOver={e => {
          e.currentTarget.style.background = 'var(--color-primary-dark)';
          e.currentTarget.style.color = '#222';
        }}
        onMouseOut={e => {
          e.currentTarget.style.background = 'var(--color-primary)';
          e.currentTarget.style.color = 'var(--color-on-primary)';
        }}
      >
        Change Password
      </button>
    </div>
  );
}
